import {BaseService} from './baseService.js';
import {Service} from './service.js';

/* 
 * Handles interaction with the plugin api
 */
export class PluginService extends BaseService {
	
	constructor() {	
		super();
	}
	
	async getPlugins() {		
		var nodes = await this.makeGETRequest('/api/resource/plugins');		
		return nodes;
	}
		
	downloadPlugin(pluginId) {			
		this.downloadFile('/api/resource/plugins/' + pluginId + '/download');		
	};
		
	async pluginStart(pluginId) {	
		var result = await this.makePUTRequest('/api/resource/plugins/' + pluginId + '/start');
		return result;
	}	

	async pluginStop(pluginId) {	
		var result = await this.makePUTRequest('/api/resource/plugins/' + pluginId + '/stop');
		return result;
	}

	async pluginRestart(pluginId) {
		var result = await this.makePUTRequest('/api/resource/plugins/' + pluginId + '/restart');
		return result;
	}
	
	async pluginRollback(pluginId) {	
		var result = await this.makePUTRequest('/api/resource/plugins/' + pluginId + '/rollback');
		return result;
	}	
	
	async uninstallJob(pluginId) {		
		var result = await this.makeDELETERequest('/api/resource/plugins/' + pluginId);		
		return result;
	}	
	
};
